{
    "Accessibility menu": "Menu ng Accessibility",
    "Close": "Isara",
    "Content adjustments": "Ayusin ang Nilalaman",
    "Navigation adjustments": "Ayusin ang Pag-navigate",
    "Text Align": "Pag-align ng Teksto",
    "Align Left": "I-align sa Kaliwa",
    "Align Center": "I-align sa Gitna",
    "Align Right": "I-align sa Kanan",
    "Adjust Font Size": "I-adjust ang Laki ng Font",
    "Highlight Title": "I-highlight ang Pamagat",
    "Highlight Links": "I-highlight ang mga Link",
    "Readable Font": "Madaling Basahing Font",
    "Colour adjustments": "Ayusin ang Kulay",
    "Dark Contrast": "Madilim na Kontrast",
    "Light Contrast": "Maliwanag na Kontrast",
    "High Contrast": "Mataas na Kontrast",
    "High Saturation": "Mataas na Saturation",
    "Low Saturation": "Mababang Saturation",
    "Monochrome": "Monokrom",
    "Tools": "Mga Kasangkapan",
    "Reading Guide": "Gabay sa Pagbabasa",
    "Big Cursor": "Malaking Cursor",
    "Increase Font Size": "Palakihin ang Laki ng Font",
    "Decrease Font Size": "Bawasan ang Laki ng Font",
    "Letter Spacing": "Espasyo ng mga Titik",
    "Line Height": "Taas ng Linya",
    "Font Weight": "Bigat ng Font",
    "Dyslexia Font": "Font para sa Dyslexia",
    "Language": "Wika",
    "Accessibility widget": "Buksan ang Menu ng Accessibility",
    "Accessibility Profiles": "Mga Profile ng Accessibility",
    "Cognitive Disability": "Kapansanan sa Kognitibo",
    "Seizure Safe": "Ligtas sa Seizure",
    "Accessibility statement": "Pahayag ng Accessibility",
    "ADHD": "ADHD",
    "Low Vision": "Mahinang Paningin",
    "Pause Animations": "Itigil ang Mga Animasyon",
    "Animation paused": "Naka-pause ang animation",
    "Reset all settings": "I-reset ang mga setting",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Ligtas sa Epilepsy na Mode",
    "Mute sounds": "I-mute ang mga tunog",
    "Page read": "Basahin ang pahina",
    "Page read controls": "Mga kontrol sa pagbasa ng pahina",
    "Pause": "I-pause",
    "Resume": "Ipagpatuloy",
    "Stop": "Itigil",
    "Settings": "Mga Setting",
    "Speed": "Bilis",
    "Voice": "Boses",
    "Close accessibility menu": "Isara ang menu ng accessibility",
    "Back to accessibility menu": "Bumalik sa menu ng accessibility",
    "Search languages": "Maghanap ng mga wika",
    "Selected language": "Napiling wika",
    "View accessibility statement (opens in new window)": "Tingnan ang pahayag sa accessibility (bubukas sa bagong window)",
    "Visit CookieYes website (opens in new window)": "Bisitahin ang website ng CookieYes (bubukas sa bagong window)",
    "Reset all accessibility settings to default": "I-reset ang lahat ng setting ng accessibility sa default"
}
